export default __webpack_public_path__ + "static/media/target-6.edf59983.png";